export default __webpack_public_path__ + "static/media/step-delay.6a901b57.svg";